module.exports = __webpack_public_path__ + "static/media/bold.771c3ec9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/bold.woff2
// module id = 50
// module chunks = 0